import { i18n as uikit } from '@vlabs/uikit';

import lunaStreams from 'partials/translations/en';

import api from './api.json';
import common from './common.json';

export default {
  common,
  api,
  ...uikit.en,
  ...lunaStreams,
};
